/**
 * Havaleyi gönderecek hesabın sahibi (PrimeVpay `customer_name`).
 *
 * Kural sunucudakiyle aynıdır (backend/services/primevpay.py
 * `clean_payer_name`): boşluklar sadeleşir, en az iki sözcük gerekir ve her
 * sözcük harf içerir. Tek sözcük (kullanıcı adı, takma ad) operasyon
 * ekibinin havaleyi gönderenle eşleştirmesine yetmez.
 */

const normalize = (value) => String(value || '').split(/\s+/).filter(Boolean).join(' ');

export const payerNameIsValid = (value) => {
  const words = normalize(value).split(' ').filter(Boolean);
  return words.length >= 2 && words.every((word) => /\p{L}/u.test(word));
};

/** Ön doldurma: KYC'li ad soyad, yoksa kayıtlı çekim hesabının sahibi. */
export const defaultPayerName = (user) => {
  const full = normalize(`${user?.first_name || ''} ${user?.last_name || ''}`);
  if (payerNameIsValid(full)) return full;
  const holder = normalize(user?.withdrawal_account_holder);
  return payerNameIsValid(holder) ? holder : '';
};
